export const poseInstructions = {
  TurtleNeck: [
    '두 팔을 들어 120c 각도를 유지한 채로 날개뼈를 모으고 고개를 들면서 팔을 몸 안쪽으로 당기는 느낌을 받으며 당겨주고, 자세를 유지합니다.',
  ],
  Arm: [
    '왼팔 또는 오른 팔을 수평으로 반대쪽 어깨 위치로 가져온 후 팔꿈치 부분에 반대 팔을 사용하여 몸쪽으로 지긋이 누르며 당겨지는 느낌을 주며 자세를 유지합니다.',
  ],
  SideNeck: [
    '왼팔 또는 오른 팔로 머리 정수리 부분에 손을 얹혀, 올린 팔쪽의 방향으로 머리를 당겨줍니다. 이때 반대쪽 팔과 어깨는 정자세를 유지합니다.',
  ],
};
